export default __webpack_public_path__ + "static/media/ALB.0db29512.svg";